let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("6oc96")).then(() => parcelRequire('8OVem'));